import { createContext, useContext, useState, useEffect, useCallback } from "react";
import useToaster from "../../components/alert";
import { getQueryResponses } from "../../api/query";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const [data, setData] = useState({ data: [], total: 0, last_page: 1 });
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchResponses = useCallback(async (page = 1) => {
    try {
      setLoading(true);
      const res = await getQueryResponses({ page, limit: 50 });
      setData(res.data);
    } catch (error) {
      toaster.error("Error", "Failed to fetch query form responses");
    } finally {
      setLoading(false);
    }
  }, [toaster]);

  useEffect(() => {
    fetchResponses(currentPage);
  }, [currentPage, fetchResponses]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <PageContext.Provider value={{ data, loading, currentPage, handlePageChange }}>
      {children}
    </PageContext.Provider>
  );
};

export const useResponsesProvider = () => {
  return useContext(PageContext);
};
